import React, { useState, useLayoutEffect, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import UndoIcon from '@mui/icons-material/Undo';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {
    InspectionContents,
    Contents,
    InspectionName,
    NomalButton,
    CautionButton,
    GrayButton
} from '../../css/CSS.js';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ClearIcon from '@mui/icons-material/Clear';


const Img = styled('img')({
});

const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        const updateSize = () => {
            setSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener('resize', updateSize);
        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
};

export default function InspectionPreviewDialog(props) {
    const handleClose = () => {
        props.cancelClick();
    };
    const handleDelete = (index) => {
        props.deleteClick(index);
    };

    const [width, height] = useWindowSize();

    const [currentCount, setCurrentCount] = useState(props.index);

    useEffect(() => {
        setCurrentCount(props.index);
    }, [props.open]);


    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            fullScreen
            PaperProps={{
                style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    height: height
                },
            }}
        >
            <DialogContent style={{ position: "relative", }} >
                <IconButton
                    sx={{ color: '#f8f7f6' }}
                    onClick={handleClose}
                    style={{
                        position: "absolute",
                        zIndex: 999
                    }} >
                    <ClearIcon sx={{ fontSize: '8rem' }} />
                </IconButton>
                {/*<CautionButton*/}
                {/*    sx={{ color: '#f8f7f6', fontSize: '2rem', px: 6, py: 2 }}*/}
                {/*    onClick={() => { handleDelete(currentCount) }}*/}
                {/*    style={{*/}
                {/*        position: "absolute",*/}
                {/*        left: '80%',*/}
                {/*        top: '5%',*/}
                {/*        zIndex: 999*/}
                {/*    }} >*/}
                {/*    <DeleteForeverIcon sx={{ fontSize: '4rem' }} />削除*/}
                {/*</CautionButton>*/}
                <Grid container
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: height,
                    }}>
                    <Box >
                        <IconButton
                            onClick={() => {
                                if (currentCount === 0) {
                                    setCurrentCount(props.src.length - 1);
                                } else {
                                    setCurrentCount(currentCount - 1);
                                }
                            }}
                        >
                            <KeyboardDoubleArrowLeftIcon sx={{ fontSize: '8rem', color: '#f8f7f6' }} />
                        </IconButton>
                    </Box>
                    <Grid item xs={8}  >
                        <Grid container
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                            <Img alt='' src={props.src[currentCount]} sx={{ maxHeight: height, maxWidth: '100%' }} />
                        </Grid>
                    </Grid>
                    <Box >
                        <IconButton
                            onClick={() => {
                                if (currentCount === props.src.length - 1) {
                                    setCurrentCount(0);
                                } else {
                                    setCurrentCount(currentCount + 1);
                                }
                            }}
                        >
                            <KeyboardDoubleArrowRightIcon sx={{ fontSize: '8rem', color: '#f8f7f6' }} />
                        </IconButton>
                    </Box>
                </Grid>
            </DialogContent>
        </Dialog >
    );
}